/**
 * Created by Mike Naughton on 9/6/17.
 * A shim for loading ESRI extensions
 */
import * as esriLoader from "esri-loader";

var NEEDED_ESRI_LIBRARIES = [
  "dijit/dijit",
  "dojo",
  "dojo/_base/Color",
  "dojo/topic",
  "esri/config",
  "esri/graphic",
  "esri/kernel",
  "esri/map",
  "esri/units",
  "esri/IdentityManager",
  "esri/IdentityManagerBase",
  "esri/SpatialReference",
  "esri/dijit/Legend",
  "esri/dijit/Measurement",
  "esri/dijit/Scalebar",
  "esri/dijit/Search",
  "esri/geometry/Extent",
  "esri/geometry/Multipoint",
  "esri/geometry/Point",
  "esri/geometry/Polygon",
  "esri/geometry/Polyline",
  "esri/geometry/geodesicUtils",
  "esri/geometry/geometryEngine",
  "esri/geometry/webMercatorUtils",
  "esri/layers/ArcGISDynamicMapServiceLayer",
  "esri/layers/FeatureLayer",
  "esri/layers/GraphicsLayer",
  "esri/layers/LabelLayer",
  "esri/symbols/Font",
  "esri/symbols/SimpleFillSymbol",
  "esri/symbols/SimpleLineSymbol",
  "esri/symbols/SimpleMarkerSymbol",
  "esri/symbols/TextSymbol",
  "esri/tasks/BufferParameters",
  "esri/tasks/GeometryService",
  "esri/tasks/PrintParameters",
  "esri/tasks/PrintTask",
  "esri/tasks/PrintTemplate",
  "esri/tasks/query",
  "esri/tasks/QueryTask",
  "esri/toolbars/draw",
  "esri/toolbars/edit",
  "esri/renderers/SimpleRenderer",
];

function shimEsri(cb) {
  esriLoader.dojoRequire(
    ["dojo/dom", "dojo/has", "dojo/i18n", "dojo/_base/kernel"].concat(
      NEEDED_ESRI_LIBRARIES
    ),
    function (dom, has, i18n, dojo) {
      var getBundleName = function (moduleName, bundleName, locale) {
        //locale = locale ? locale.toLowerCase() : dojo.locale;
        locale = locale ? locale.toLowerCase() : dojo.locale;
        moduleName = moduleName.replace(/\./g, "/");
        bundleName = bundleName.replace(/\./g, "/");

        return moduleName + "/nls/" + bundleName + "/" + locale;
      };

      i18n.getLocalization = function (moduleName, bundleName, locale) {
        var fullName = getBundleName(moduleName, bundleName, locale);

        return i18n.cache[fullName];
      };

      //monkey patching dom.isDescendant because of this https://bugs.dojotoolkit.org/ticket/18824
      //seems to be a result of the upgrade to esri 3.17
      dom.isDescendant = has("dom-contains")
        ? // FF9+, IE9+, webkit, opera, iOS, Android, Edge, etc.
          function (/*DOMNode|String*/ node, /*DOMNode|String*/ ancestor) {
            try {
              ancestor = dom.byId(ancestor);
              if (!ancestor.contains) {
                //dealing with at least one widget
                node = dojo.dijit.byId(node);
                while (node) {
                  if (node == ancestor) {
                    return true;
                  }
                  node = node.parentNode;
                }
              } else {
                return ancestor.contains && ancestor.contains(dom.byId(node));
              }
            } catch (e) {
              //squelch the error and just return false
            }

            return false;
          }
        : function (/*DOMNode|String*/ node, /*DOMNode|String*/ ancestor) {
            // summary:
            //    Returns true if node is a descendant of ancestor
            // node: DOMNode|String
            //    string id or node reference to test
            // ancestor: DOMNode|String
            //    string id or node reference of potential parent to test against
            //
            // example:
            //    Test is node id="bar" is a descendant of node id="foo"
            //  | require(["dojo/dom"], function(dom){
            //  |   if(dom.isDescendant("bar", "foo")){ ... }
            //  | });

            try {
              node = dom.byId(node);
              ancestor = dom.byId(ancestor);
              while (node) {
                if (node == ancestor) {
                  return true;
                  // Boolean
                }
                node = node.parentNode;
              }
            } catch (e) {
              /* squelch, return false */
            }
            return false;
            // Boolean
          };

      cb();
    }
  );
}

var ALREADY_LOADED = "The ArcGIS API for JavaScript is already loaded.";

export default {
  init: function (cb) {
    esriLoader.bootstrap(
      function (err) {
        if (err && err.message != ALREADY_LOADED) {
          return cb(err);
        }

        shimEsri(function () {
          cb();
        });
      },
      {
        url: "https://js.arcgis.com/3.20/",
      }
    );
  },
};



//////////////////
// WEBPACK FOOTER
// ./public/js/app/esri-shim.js
// module id = 504
// module chunks = 1